var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
export var FigureKey = styled.path(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fill: ", ";\n"], ["\n    fill: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorTextRestButton;
});
export function LoginKeyIcon() {
    return (React.createElement("svg", { viewBox: "0 0 32 32", width: "32px", height: "32px" },
        React.createElement("path", { fill: "currentColor", d: "M16,32A16,16,0,1,0,0,16,16,16,0,0,0,16,32Z" }),
        React.createElement(FigureKey, { d: "M15,13,8,20v4h4V22h2V20h2l2.05-2.05,1.2-1.2Zm-5,9V20.586l5.293-5.293L16,16Z" }),
        React.createElement(FigureKey, { d: "M19,8a4.994,4.994,0,0,0-4.168,7.754l.461-.461L16,16l-.536.536A5,5,0,1,0,19,8Zm2.121,7.121-4.242-4.242A3,3,0,0,1,21.2,15.047C21.171,15.072,21.146,15.1,21.121,15.121Z" })));
}
var templateObject_1;
//# sourceMappingURL=LoginKeyIcon.js.map